import React from 'react';
import { Index, Configure, connectStateResults } from 'react-instantsearch-dom';
import { Link } from 'react-router-dom';

import { stripDomain } from 'src/util/sanitizeLink';

import CustomHighlight from './Highlight';
import classes from './SearchInner.scss';
import { NoResults } from './NoResults';

type AlgoliaPagesProps = {
    index: string;
};

export const CustomPageHits = connectStateResults(({ searchResults, searching }) => {
    const hits = searchResults?.hits;
    const hasResults = !searching && hits && hits?.length > 0;

    return (
        <div className={classes.root}>
            <h3 className={classes.title}>Information</h3>

            {!hasResults && <NoResults />}

            {hasResults && (
                <ul className={classes.listHits}>
                    {hits.map((hit) => (
                        <li key={hit.objectID} className={classes.listItem}>
                            <Link to={stripDomain(hit.url)} className={classes.listItemLink}>
                                <CustomHighlight attribute="name" hit={hit} />
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
});

export function AlgoliaPages(props: AlgoliaPagesProps) {
    return (
        <Index indexName={props.index}>
            <Configure hitsPerPage={3} />
            <CustomPageHits />
        </Index>
    );
}
